var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "os-navbar", attrs: { toggleable: "lg" } },
    [
      _c(
        "b-nav-item",
        { staticClass: "d-block d-xl-none" },
        [
          _c(
            "router-link",
            { attrs: { to: "/inicio-sesion" } },
            [
              _c("base-icon", {
                staticStyle: { height: "2.5rem", width: "2.5rem" },
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg",
                  color: "#3238C4"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar-brand",
        { staticClass: "mx-auto mx-xl-0", attrs: { href: "/" } },
        [
          _c("img", {
            staticClass: "navbar-brand-img",
            attrs: {
              src: "/static-appopensalud/img/logos/RGB_OPENSALUD_AZUL.svg",
              alt: "opensalud"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { id: "nav-collapse", "is-nav": "" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "os-navbar-dropdown ml-xl-auto" },
            [
              _c("b-nav-item", { attrs: { href: "#" } }, [_vm._v("Link")]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { href: "#", disabled: "" } }, [
                _vm._v("Disabled")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92015852", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92015852","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/BasePublicNavbar.vue
// module id = 3977
// module chunks = 111